import { Link } from 'react-router-dom'
import React, { useContext, useState } from 'react'
import "../store.css"
import { CartContext } from '../../context/CartContext'
import { useProductsContext } from '../../hooks/useProductsContext'
import CartItem from '../components/CartItem'
import StripeCheckout from 'react-stripe-checkout';
import { useAuthContext } from '../hooks/useAuthContext'


function ShoppingCart() {

  const publishableKey = 'pk_test_51NUok6Alkkdr7Bs2RUnzf4Ik3Zx2l7NLzVVs5PhP34fJGGQCJvveO9CGG6d073xmJrgqB2iGxG9pVVQtoNX6ZXcB00eRDzpidB'
  const {user} = useAuthContext()
  console.log("user", user)
    const { cartItems,  emptyCart,calculateTotalAmount } = useContext(CartContext)
    const {products} = useProductsContext()
    console.log("cartItems", cartItems)
    const [error, setError] = useState(null);
    const [btnText, setBtnText] = useState("Place Order")
    const totalAmount = calculateTotalAmount()
    const [shopText, setShopText] = useState("You have no items in your cart")
    const [paymentOption, setPaymentOption] = useState("Card") // Default to COD option
    console.log("paymentOption", paymentOption)
    const [customerName, setCustomerName] = useState('');
    const [customerAddress, setCustomerAddress] = useState('');
   
     const cartItemElements = cartItems && Object.keys(cartItems).map((itemId) => {
        if (cartItems[itemId] !== 0) {
          const item = products.find((product) => product._id === itemId);
          if (item) {
            return <CartItem key={item._id} item={item} />;
          }
        }
        return null;
      });

      function placeOrder() {
        if (!user) {
          setError('You must be logged in to place an order');
          console.log('You must be logged in to place an order')
          return;
        }
    
        const orderItems = Object.keys(cartItems).map((itemId) => {
          if (cartItems[itemId] !== 0) {
            return {
              product: itemId,
              quantity: cartItems[itemId],
            };
          }
          return null;
        });
    
        if (paymentOption === 'COD') {
          // Order data for Cash on Delivery
          const orderData = {
            user: user._id,
            products: orderItems.filter((item) => item !== null),
           // paymentMethod: 'COD', // Indicate Cash on Delivery payment method
           // username: customerName,
          //  address: customerAddress,
          };
    
          console.log("orderData", orderData)
          // Send the order data to the backend to create the order
          fetch('http://localhost:4000/api/orders/create', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(orderData),
          })
            .then((response) => response.json())
            .then((data) => {
              // Order placed successfully
              setBtnText("Order Placed");
              setShopText("Order placed successfully");
              emptyCart();
              console.log("data", data)
            })
            .catch((error) => {
              setError('Failed to place the order. Please try again.');
            });
        } else if (paymentOption === 'Card') {

       payNow()
       const orderData = {
        user: user._id,
        products: orderItems.filter((item) => item !== null),
       // paymentMethod: 'Card', // Indicate Cash on Delivery payment method
        username: customerName,
        address: customerAddress,
      };

      // Send the order data to the backend to create the order
      fetch('http://localhost:4000/api/orders/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(orderData),
      })
        .then((response) => response.json())
        .then((data) => {
          // Order placed successfully
          setBtnText("Order Placed");
          setShopText("Order placed successfully");
          emptyCart();
        })
        .catch((error) => {
          setError('Failed to place the order. Please try again.');
        });

        }
      }
  

    const payNow = async (token) => {
      try {
        console.log("token of paynow", token)
        const response = await fetch({
          url: 'http://localhost:4000/api/stripe/payment',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            amount: totalAmount,
            token,
          }),
        });
        if (response.status === 200) {
         console.log(response)
        }
      } catch (error) {
        //handleFailure();
        console.log(error);
      }


    }

    return (

      <main className="cart-page">
    

      {/* Cart items */}
      <div className="cart-items-container">
      <h1>Check out</h1>
        {cartItemElements}
      </div>

      {totalAmount !== 0 ? (
        // Order details
        <div className="order-details-container">
          <h2>Total amount: $ {totalAmount} </h2>

          {/* Payment options dropdown */}
          <div className="payment-options">
            <label>Select Payment Method:</label>
            <select
              name="paymentOption"
              value={paymentOption}
              onChange={(e) => setPaymentOption(e.target.value)}
            >
              <option value="COD">Cash on Delivery (COD)</option>
              <option value="Card">Credit Card</option>
            </select>
          </div>

          {/* Additional fields for Cash on Delivery */}
          {paymentOption === 'COD' && (
            <div>
              <label>Customer Name: </label>
              <input
                type="text"
                value={customerName}
                onChange={(e) => setCustomerName(e.target.value)}
              />
              <br />
              <label>Address:  &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
              <input
                type="text"
                value={customerAddress}
                onChange={(e) => setCustomerAddress(e.target.value)}
              />
              
          <button onClick={placeOrder} className="addtocart-btn">
            {btnText}
          </button>
            </div>
          )}

          {/* Stripe Checkout */}
          {paymentOption === 'Card' && (
            <StripeCheckout
              stripeKey={publishableKey}
              label="Pay Now & Order"
              name="Pay With Credit Card"
              billingAddress
              shippingAddress
              amount={totalAmount}
              description={`Your total is $${totalAmount}`}
              token={placeOrder}
            />
          )}

        </div>
      ) : (
        <div>
          <p>{shopText}</p>
          <Link to="/" className="links">
            <h3>
              <span>Back to shopping</span>
            </h3>
          </Link>
        </div>
      )}
    </main>
    )
}

export default ShoppingCart
